import Vue from 'vue'
import * as Y from 'yjs'
import { base64ToBytes } from 'byte-base64'
import { ItemDataUpdate } from 'src/assets/ItemDataLive'

export default class ItemData {
  info: { [key: string]: Json } = {}
  slides: { [key: string]: Json } = {}
  corrects: Json = {}

  constructor (itemDataUpdate: ItemDataUpdate) {
    this.update(itemDataUpdate)
  }

  update (itemDataUpdate: ItemDataUpdate) {
    this.updateProperties(this.info, itemDataUpdate.infoSettings || {})
    this.updateTexts(this.info, itemDataUpdate.infoTexts || {})
    this.updateProperties(this.slides, itemDataUpdate.slidesSettings || {})
    this.updateTexts(this.slides, itemDataUpdate.slidesTexts || {})
    this.updateProperties(this.corrects, itemDataUpdate.slidesCorrects || {})
  }

  updateProperties (target: { [key: string]: Json }, updates: Json) {
    for (const [key, value] of Object.entries(updates)) {
      const path = key.split(':')
      const pathtarget = this.getPathTarget(target, path)
      const property = path.pop()
      if (property) {
        if (value === null) {
          Vue.delete(pathtarget, property)
        } else {
          Vue.set(pathtarget, property, value)
        }
      }
    }
  }

  updateTexts (target: { [key: string]: Json }, updates: { [key: string]: string[] }) {
    for (const [key, value] of Object.entries(updates)) {
      const path = key.split(':')
      const pathtarget = this.getPathTarget(target, path)
      const property = path.pop()
      if (property) {
        if (value === null) {
          Vue.delete(pathtarget, property)
        } else {
          if (pathtarget[property] === undefined) {
            Vue.set(pathtarget, property, new Y.Doc())
          }
          const doc = pathtarget[property] as Y.Doc
          for (const update of value) {
            Y.applyUpdate(doc, base64ToBytes(update))
          }
        }
      }
    }
  }

  getPathTarget (target: { [key: string]: Json }, path: string[]) {
    while (path.length > 1) {
      const property = path.shift()
      if (property) {
        if (!target[property]) {
          target[property] = {}
        }
        target = target[property]
      }
    }
    return target
  }
}
